'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setHost = exports.factory = undefined;

var _tracker = require('./lib/tracker');

var tracker = _interopRequireWildcard(_tracker);

var _logger = require('./logger');

var logger = _interopRequireWildcard(_logger);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var factory = exports.factory = function factory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var trackSession = options.trackSession || typeof options.trackSession === 'undefined';

  if (trackSession) {
    tracker.track(logger.factory);
  }

  return logger.factory(options);
};

var setHost = exports.setHost = logger.setHost;

exports.default = {
  factory: factory,
  setHost: logger.setHost
};